'use client'
import stylesModule from '@/domains/Account/modules/Mktu/Mktu.module.scss'
import { SelectWordsStore } from '@/domains/Account/modules/Mktu/store'
import { Icon } from '@/icons'
import { MktuClassWord } from '@/services/Api/generated'
import { ListSelectedWordsPopup } from '@/shared/Mktu/components/ListSelectedWordsPopup'
import { MktuClassListPopup } from '@/shared/Mktu/components/MktuClassListPopup'
import { MktuClassPopup } from '@/shared/Mktu/components/MktuClassPopup'
import { SelectWordsPopup } from '@/shared/Mktu/components/SelectWordsPopup'
import { SearchMktuClassStore } from '@/store/Mktu/SearchMktuClass'
import { POPUP_TYPE, popupStore } from '@/store/Popup'
import { disableBodyScroll, enableBodyScroll } from '@/utils/dom'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import { FunctionComponent, useCallback } from 'react'
import styles from './SearchMktuClasses.module.scss'
import { UISearchMktuClasses } from './UISearchMktuClassess.store'

const storeSelectWords = new SelectWordsStore()

const defaultUiStore = new UISearchMktuClasses()

interface SearchMktuClassesProps {
  store: SearchMktuClassStore
  uiStore?: UISearchMktuClasses
  onApply: () => void
  className?: string
}
export const SearchMktuClasses: FunctionComponent<SearchMktuClassesProps> =
  observer(({ store, onApply, className, uiStore = defaultUiStore }) => {
    const close = useCallback(() => {
      storeSelectWords.resetToDefault()
      uiStore.reset()
      enableBodyScroll()
    }, [uiStore])

    const closeWithApprove = useCallback(() => {
      if (storeSelectWords.selectedWords.length !== 0) {
        popupStore.showPopup(POPUP_TYPE.ACCEPT_POPUP, {
          onClose: (accepted: boolean) => {
            if (accepted) {
              close()
            }
          },
          title: 'Вы уверены что хотите закрыть?',
          description: 'После закрытия отменятся выбранные слова',
          acceptButton: 'Закрыть',
          cancelButton: 'Отмена',
        })
      } else {
        close()
      }
    }, [close])

    const selectClassesByWords = useCallback(async () => {
      if (store.validate()) {
        uiStore.popupSelectedMktuClasses.show()
        await store.findClassesByWords()
        disableBodyScroll()
      }
    }, [store, uiStore])

    const hideListClassesPopup = useCallback(() => {
      uiStore.popupSelectedMktuClasses.hide()
      uiStore.popupSelectWords.show()
    }, [])

    const showListSelectedWordsPopup = useCallback(() => {
      uiStore.popupListSelectedWords.show()
      uiStore.popupSelectWords.hide()
    }, [])

    const hideListSelectedWordsPopup = useCallback(() => {
      uiStore.popupListSelectedWords.hide()
      uiStore.popupSelectWords.show()
    }, [])

    const applyEditMktuClass = useCallback(
      (names: MktuClassWord['word'][]) => {
        uiStore.editableMktuClass.setSelectedWordsNames(names)
        uiStore.endEditMktuClass()
      },
      [uiStore]
    )

    const showSelectWordPopup = useCallback(() => {
      disableBodyScroll()
      uiStore.popupSelectWords.show()
    }, [uiStore])

    const selectWords = useCallback(
      (words: MktuClassWord[]) => {
        uiStore.popupSelectWords.hide()
        store.setSelectedWords(words)
        selectClassesByWords()
      },
      [selectClassesByWords, store, uiStore]
    )

    const deleteWord = useCallback((word: MktuClassWord) => {
      storeSelectWords.setSelectedWords(word)
    }, [])

    const apply = useCallback(() => {
      uiStore.popupSelectedMktuClasses.hide()
      storeSelectWords.resetToDefault()
      enableBodyScroll()
      onApply()
    }, [onApply, uiStore])

    return (
      <>
        <button
          className={cn(styles.button, className)}
          onClick={showSelectWordPopup}
        >
          <Icon name="search" className={styles.iconSearch} />
          Название товара или услуги
        </button>

        {uiStore.popupSelectWords.isVisible ? (
          <SelectWordsPopup
            onClose={closeWithApprove}
            onApply={selectWords}
            store={storeSelectWords}
            onShowAllList={showListSelectedWordsPopup}
          />
        ) : null}

        {uiStore.popupListSelectedWords.isVisible ? (
          <ListSelectedWordsPopup
            words={storeSelectWords.selectedWords}
            onClose={closeWithApprove}
            onBack={hideListSelectedWordsPopup}
            onDelete={deleteWord}
          />
        ) : null}

        {uiStore.popupSelectedMktuClasses.isVisible ? (
          <MktuClassListPopup
            className={cn({
              [stylesModule.hidePopup]: uiStore.popupMktuClass.isVisible,
            })}
            store={store}
            onApply={apply}
            onCancel={hideListClassesPopup}
            onClose={closeWithApprove}
            showSelectWordsPopup={uiStore.startEditMktuClass}
            selectedClasses={store.selectedFoundClasses}
          />
        ) : null}

        {uiStore.popupMktuClass.isVisible &&
        uiStore.editableMktuClass != null ? (
          <MktuClassPopup
            onBack={uiStore.endEditMktuClass}
            onClose={closeWithApprove}
            onApplyWords={applyEditMktuClass}
            mktuClass={uiStore.editableMktuClass}
            withBackButton
            backButtonText="Назад к классам"
          />
        ) : null}
      </>
    )
  })
